import countries from "i18n-iso-countries";
import en from 'i18n-iso-countries/langs/en.json'
import hu from 'i18n-iso-countries/langs/hu.json'

countries.registerLocale(en);
countries.registerLocale(hu);

export { countries };